import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Output from "./OutPut";
import CodeEditor from "./CodeEditor";
import "./CodeIDE.css"

function CodeIDE() {
  const location = useLocation();
  const data = location.state;
  const [code, setCode] = useState(data || "");
  const [language, setLanguage] = useState("javascript");
  const [output, setOutput] = useState("");

  const handleRunCode = () => {
    setOutput("");
    try {
      // Execute JavaScript code
      if (language === "javascript") {
        const originalConsoleLog = console.log;
        console.log = (message) => {
          setOutput((prevOutput) => prevOutput + message + "\n");
        };
        // Execute the JavaScript code provided by the user
        // eslint-disable-next-line
        new Function(`return ${code}`)();
        // Restore original console.log after execution
        console.log = originalConsoleLog;
      } else {
        // For other languages, display code as is
        setOutput(code);
      }
    } catch (error) {
      // Handle errors
      setOutput(`Error: ${error.message}`);
    }
  };

  return (
    <div className="CodeIDE flex flex-col h-screen overflow-auto">
      {/* Header */}
      <header className="bg-gray-800 flex text-white p-4 ">
        <h1 className="text-2xl font-bold">Code IDE</h1>
        <select
          className="ml-4 px-3 py-2 rounded"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option value="">Select Language</option>
            <option value="javascript">JavaScript</option>
            <option value="html">Html</option>
            {/* <option value="css">CSS</option> */}
            {/* <option value="java">Java</option>
            <option value="python">Python</option>
            <option value="node js">Node JS</option>

            <option value="c++">C++</option>
            <option value="c">C</option>
            <option value="c#">C#</option>
            <option value="ruby">Ruby</option>
            <option value="php">PHP</option>
            <option value="rust">Rust</option>
            <option value="swift">Swift</option>
            <option value="kotlin">Kotlin</option>
            <option value="scala">Scala</option>
            <option value="go">Go</option>
            <option value="r">R</option>
            <option value="dart">Dart</option>
            <option value="racket">Racket</option>
            <option value="haskell">Haskell</option>
            <option value="f#">F#</option> */}
        </select>
        <button
          className="bg-blue-500 ml-4 hover:bg-blue-600 text-white py-2 px-4 rounded"
          onClick={handleRunCode}
        >
          Run Code
        </button>
      </header>

      <div className="mainwarp flex-grow flex">

        <div className="w-1/2 p-2 border-r-2 border-gray-800 ">
          <CodeEditor
            value={code}
            onChange={(newCode) => setCode(newCode)}
            language={language}
            onLanguageChange={(newLanguage) => setLanguage(newLanguage)}
          />
        </div>

        <div className="w-1/2 p-2">
          <Output
            handleRunCode={handleRunCode}
            codeOutput={output}
            language={language}
          />
        </div>
      </div>
    </div>
  );
}

export default CodeIDE;
